// UserContext.js
import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUserData] = useState(null);
  
  const updateUser = (newUserData) => {
    setUserData(newUserData);
  };


  const isCurrentUserSuperAdmin = () => {
    return user?.role == 'super_admin';
  };

  const isUserLoggedIn = () => {
    return user !== null;
  };


  return (
    <UserContext.Provider value={{ user, updateUser, isCurrentUserSuperAdmin, isUserLoggedIn}}>
      {children}
    </UserContext.Provider>
  );
};

UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
